import { Routes } from '@angular/router';
import { everydaySpendCanMatch } from '@features/everyday-spend/guards/everyday-spend.guard';
import { AuthGuard } from '@rd/core/auth/guards/auth.guard';
import { MultiCardSelectGuard } from '@rd/core/guards/multi-card-select/multi-card-select.guard';
import { ShoppingCartFeatureGuard } from '@rd/core/guards/shopping-cart-feature/shopping-cart-feature.guard';
import { AnzGiftCardUnavailableComponent } from '@rd/wl/anz/views/gift-card-unavailable/gift-card-unavailable.component';
import { AnzHomePageComponent } from '@rd/wl/anz/views/home-page/home-page.component';
import { AnzPageNotFoundComponent } from '@rd/wl/anz/views/page-not-found/page-not-found.component';
import { MultiCardSelectComponent } from './views/multi-card-select/multi-card-select.component';

export const routes: Routes = [
  {
    path: '',
    component: AnzHomePageComponent,
  },
  {
    path: 'shopping-cart',
    loadChildren: () =>
      import('./shopping-cart/shopping-cart-wrapper.module').then(
        (m) => m.ShoppingCartWrapperModule,
      ),
    canActivate: [ShoppingCartFeatureGuard],
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./order/order-wrapper.module').then((m) => m.OrderWrapperModule),
  },
  {
    path: 'gift_card',
    loadChildren: () =>
      import('./gift-card/gift-card-wrapper.module').then(
        (m) => m.GiftCardWrapperModule,
      ),
  },
  {
    path: 'select-card',
    component: MultiCardSelectComponent,
    canActivate: [AuthGuard, MultiCardSelectGuard],
  },
  {
    path: 'points_activity',
    loadChildren: () =>
      import('./points-transaction/points-transaction-wrapper.module').then(
        (m) => m.PointsTransactionWrapperModule,
      ),
  },
  {
    path: 'transfer',
    loadChildren: () =>
      import('./transfer-connect-v2/transfer-connect-v2-wrapper.module').then(
        (m) => m.TransferConnectV2WrapperModule,
      ),
  },
  {
    path: 'redeem_cash',
    loadChildren: () =>
      import('./redeem-cash-v2/redeem-cash-v2-wrapper.module').then(
        (m) => m.RedeemCashWrapperModule,
      ),
  },
  {
    path: 'merchandise',
    loadChildren: () =>
      import('./merchandise/merchandise-wrapper.module').then(
        (m) => m.MerchandiseWrapperModule,
      ),
  },
  {
    path: 'campaign-page',
    loadChildren: () =>
      import('./campaign-page/campaign-page-wrapper.module').then(
        (m) => m.CampaignPagesWrapperModule,
      ),
  },
  {
    path: 'promo-page',
    loadChildren: () =>
      import('./promo-page/promo-page-wrapper.module').then(
        (m) => m.PromoPageWrapperModule,
      ),
  },
  {
    path: 'everyday_rewards',
    loadChildren: () =>
      import('./everyday-spend/everyday-spend-wrapper.module').then(
        (m) => m.EverydaySpendWrapperModule,
      ),
    canMatch: [everydaySpendCanMatch],
  },
  {
    path: 'failure/gift-card-unavailable',
    component: AnzGiftCardUnavailableComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./static-pages/static-pages-wrapper.module').then(
        (m) => m.StaticPagesWrapperModule,
      ),
  },
  {
    path: '**',
    component: AnzPageNotFoundComponent,
  },
];
